import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { DropdownObject } from 'src/app/shared/classes/base-form';

@Component({
	selector: 'app-dynamic-dropdown-search',
	templateUrl: './dynamic-dropdown-search.component.html',
	styleUrls: ['./dynamic-dropdown-search.component.scss'],
	viewProviders: [
		{ provide: ControlContainer, useExisting: FormGroupDirective }
	]
})
export class DynamicDropdownSearchComponent {
	@Input() field: any;
	@Output() valueChanged: EventEmitter<string> = new EventEmitter<any>();
	@Output() lostFocus: EventEmitter<string> = new EventEmitter<string>();
	@Output() optionSelected = new EventEmitter<any[]>();

	inputValue = '';
	selectedCities: any[] = new Array<any>();

	constructor(public controlContainer: ControlContainer) {}

	displayFn(city: any): string {
		return city && city.value ? city.value : ''; // Display the city name in the input field when a city is selected
	}

	onBlur() {
		this.lostFocus.emit();
	}

	getTooltip(option: any): string {
		if (this.field?.tooltip != null) {
			const tooltipList = this.field?.tooltip as Array<DropdownObject>;

			return tooltipList.find(x => x.key === option.key)?.value || '';
		}
		return '';
	}

	optionClicked(event: any, user: any) {
		event.stopPropagation();
		this.toggleSelection(user);
	}

	onOptionSelected(event: MatAutocompleteSelectedEvent) {
		const selectedValue = event.option.value;
		this.optionSelected.emit(selectedValue);
	}

	toggleSelection(city: any) {
		city.selected = !city.selected;
		if (city.selected) {
			this.selectedCities.push(city);
		} else {
			const i = this.selectedCities.findIndex(
				value => value.value === city.value
			);
			this.selectedCities.splice(i, 1);
		}
		this.optionSelected.emit(this.selectedCities);
	}

	displayFnMultiple(value: string): string {
		let displayValue = '';
		if (Array.isArray(value)) {
			value.forEach((city, index) => {
				if (index === 0) {
					displayValue = city.value;
				} else {
					displayValue += ', ' + city.value;
				}
			});
		} else {
			displayValue = value;
		}
		return displayValue;
	}
}
